module.exports = __webpack_public_path__ + "img/img_logo@2x.6a3d1263.png";